(() => {
  const OPTIONS = [
    { value: 'Instagram', label: 'Instagram', icon: '◎', placeholder: 'tuusuario', help: 'No hace falta escribir @.', inputmode: 'text', prefix: '@', inputLabel: 'Usuario de Instagram' },
    { value: 'TikTok', label: 'TikTok', icon: '♪', placeholder: 'tuusuario', help: 'No hace falta escribir @.', inputmode: 'text', prefix: '@', inputLabel: 'Usuario de TikTok' },
    { value: 'WhatsApp', label: 'WhatsApp', icon: '↗', placeholder: '34600000000', help: 'Pon el número con prefijo, sin espacios si quieres.', inputmode: 'tel', prefix: '', inputLabel: 'Número de WhatsApp' },
    { value: 'Web o enlace', label: 'Web / enlace', icon: '⌁', placeholder: 'https://tuweb.com', help: 'Pega el enlace completo.', inputmode: 'url', prefix: '', inputLabel: 'Enlace completo' },
    { value: 'Contacto digital', label: 'Contacto', icon: '＋', placeholder: 'Nombre, teléfono o email', help: 'Escribe el dato principal que quieres compartir.', inputmode: 'text', prefix: '', inputLabel: 'Dato de contacto' },
    { value: 'Otro', label: 'Otro', icon: '✦', placeholder: 'Explica qué debe abrir', help: 'Describe brevemente el contenido que debe abrir.', inputmode: 'text', prefix: '', inputLabel: 'Contenido a guardar' }
  ];

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

  const optionByValue = (value) => OPTIONS.find((item) => item.value === value) || null;
  const stripPrefix = (value = '', prefix = '@') => String(value).replace(new RegExp(`^\\${prefix}+`), '').trim();

  const cardMarkup = (index, values = {}) => {
    const number = index + 1;
    const title = `Tarjeta ${number}`;
    const chosen = optionByValue(values.type);
    const visibleValue = chosen && chosen.prefix === '@' ? stripPrefix(values.content || '', '@') : (values.content || '');
    const choices = OPTIONS.map((item) => `
      <button type="button" class="nsc-destination${values.type === item.value ? ' is-selected' : ''}"
        data-nsc-destination data-value="${escapeHtml(item.value)}" aria-pressed="${values.type === item.value ? 'true' : 'false'}">
        <span class="nsc-destination__icon" aria-hidden="true">${escapeHtml(item.icon)}</span>
        <span class="nsc-destination__label">${escapeHtml(item.label)}</span>
      </button>`).join('');

    return `
      <fieldset class="nsc-card-config${chosen ? ' has-destination' : ''}" data-nsc-card="${number}">
        <legend class="nsc-card-config__head">
          <span class="nsc-card-config__number">${String(number).padStart(2, '0')}</span>
          <span class="nsc-card-config__heading">
            <strong>${title}</strong>
            <small>${number === 1 ? 'Contenido de la tarjeta' : 'Contenido independiente'}</small>
          </span>
          <span class="nsc-card-config__status" data-nsc-status>Pendiente</span>
        </legend>

        <div class="nsc-card-config__body">
          <div class="nsc-fieldset-group">
            <span class="nsc-field__title" id="nsc-destination-label-${number}">¿Qué quieres guardar?</span>
            <div class="nsc-destination-grid" role="group" aria-labelledby="nsc-destination-label-${number}">${choices}</div>
            <input type="hidden" name="properties[${title} · Tipo]" value="${escapeHtml(values.type || '')}" required data-nsc-type>
          </div>

          <label class="nsc-field nsc-field--content${chosen ? '' : ' is-disabled'}">
            <span class="nsc-field__title" data-nsc-content-label>${chosen ? escapeHtml(chosen.inputLabel) : 'Dato a guardar'}</span>
            <span class="nsc-input-shell">
              <span class="nsc-input-shell__prefix" data-nsc-prefix ${chosen && chosen.prefix ? '' : 'hidden'}>${chosen && chosen.prefix ? escapeHtml(chosen.prefix) : ''}</span>
              <input type="hidden" name="properties[${title} · Contenido]" value="${escapeHtml(values.content || '')}" data-nsc-content>
              <input type="text" value="${escapeHtml(visibleValue)}"
                placeholder="${chosen ? escapeHtml(chosen.placeholder) : 'Primero elige una opción'}" maxlength="500"
                autocomplete="off" required data-nsc-content-visible ${chosen ? '' : 'disabled'} inputmode="${chosen ? chosen.inputmode : 'text'}">
            </span>
            <small class="nsc-field__help" data-nsc-content-help>${chosen ? escapeHtml(chosen.help) : 'Elige arriba qué quieres guardar en la tarjeta.'}</small>
          </label>

          <label class="nsc-field nsc-field--notes">
            <span class="nsc-field__title">Notas <em>Opcional</em></span>
            <textarea name="properties[${title} · Notas]" placeholder="Solo si quieres indicar algún detalle especial" maxlength="500" data-nsc-notes>${escapeHtml(values.notes || '')}</textarea>
          </label>
        </div>
      </fieldset>`;
  };

  const init = (root) => {
    if (root.dataset.nscReady === 'true') return;
    root.dataset.nscReady = 'true';
    const form = root.closest('form');
    if (!form) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    const cardsContainer = root.querySelector('[data-nsc-card-configs]');
    const quantityNote = root.querySelector('[data-nsc-quantity-note]');
    const quantityTitle = root.querySelector('[data-nsc-quantity-title]');
    const quantityCopy = root.querySelector('[data-nsc-quantity-copy]');
    const copyActions = root.querySelector('[data-nsc-copy-actions]');
    const copyButton = root.querySelector('[data-nsc-copy-first]');
    const configuredQuantity = root.querySelector('[data-nsc-configured-quantity]');
    const validation = root.querySelector('[data-nsc-validation]');
    const maxCards = Math.max(1, Number(root.dataset.maxCards || 50));
    let currentQuantity = 0;

    const purchaseControls = () => ({
      addButtons: [...form.querySelectorAll('button[name="add"], [data-testid="standalone-add-to-cart"], .add-to-cart-button')],
      accelerated: [...form.querySelectorAll('.accelerated-checkout-block')]
    });

    const rememberAvailability = () => {
      purchaseControls().addButtons.forEach((button) => {
        if (!("nscInitiallyDisabled" in button.dataset)) button.dataset.nscInitiallyDisabled = button.disabled ? 'true' : 'false';
      });
    };

    const getValues = () => [...cardsContainer.querySelectorAll('[data-nsc-card]')].map((card) => ({
      type: card.querySelector('[data-nsc-type]')?.value || '',
      content: card.querySelector('[data-nsc-content]')?.value || '',
      notes: card.querySelector('[data-nsc-notes]')?.value || ''
    }));

    const updateHiddenContent = (card) => {
      const type = card.querySelector('[data-nsc-type]')?.value || '';
      const option = optionByValue(type);
      const visibleInput = card.querySelector('[data-nsc-content-visible]');
      const hiddenInput = card.querySelector('[data-nsc-content]');
      if (!visibleInput || !hiddenInput) return;
      let raw = visibleInput.value.trim();
      if (option?.prefix === '@') {
        raw = stripPrefix(raw, '@');
        visibleInput.value = raw;
        hiddenInput.value = raw ? `@${raw}` : '';
      } else {
        hiddenInput.value = raw;
      }
    };

    const isCardComplete = (card) => {
      const type = card.querySelector('[data-nsc-type]')?.value.trim();
      const content = card.querySelector('[data-nsc-content-visible]')?.value.trim();
      return Boolean(type && content);
    };

    const updatePurchaseState = () => {
      rememberAvailability();
      const cards = [...cardsContainer.querySelectorAll('[data-nsc-card]')];
      const complete = cards.length > 0 && cards.every(isCardComplete);
      const controls = purchaseControls();
      controls.addButtons.forEach((button) => {
        const unavailable = button.dataset.nscInitiallyDisabled === 'true';
        button.disabled = unavailable || !complete;
        button.setAttribute('aria-disabled', String(unavailable || !complete));
        button.classList.toggle('nsc-purchase-locked', !complete);
      });
      controls.accelerated.forEach((block) => {
        block.hidden = !complete;
        block.setAttribute('aria-hidden', String(!complete));
        block.classList.toggle('nsc-checkout-locked', !complete);
      });
      root.classList.toggle('is-complete', complete);
      if (validation) {
        validation.classList.toggle('is-complete', complete);
        validation.innerHTML = complete
          ? '<span aria-hidden="true">✓</span><span>Personalización completa. Ya puedes comprar.</span>'
          : '<span aria-hidden="true">ⓘ</span><span>Completa cada tarjeta para activar la compra.</span>';
      }
      return complete;
    };

    const updateStatus = (card) => {
      updateHiddenContent(card);
      const complete = isCardComplete(card);
      card.classList.toggle('is-complete', complete);
      const status = card.querySelector('[data-nsc-status]');
      if (status) status.textContent = complete ? 'Lista' : 'Pendiente';
      updatePurchaseState();
    };

    const setDestination = (card, value) => {
      const selected = optionByValue(value);
      const hiddenType = card.querySelector('[data-nsc-type]');
      const visibleInput = card.querySelector('[data-nsc-content-visible]');
      const label = card.querySelector('[data-nsc-content-label]');
      const help = card.querySelector('[data-nsc-content-help]');
      const prefix = card.querySelector('[data-nsc-prefix]');
      const field = card.querySelector('.nsc-field--content');
      hiddenType.value = value;
      card.querySelectorAll('[data-nsc-destination]').forEach((button) => {
        const active = button.dataset.value === value;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      card.classList.toggle('has-destination', Boolean(selected));
      field.classList.toggle('is-disabled', !selected);
      visibleInput.disabled = !selected;
      if (selected) {
        label.textContent = selected.inputLabel;
        visibleInput.placeholder = selected.placeholder;
        visibleInput.inputMode = selected.inputmode;
        help.textContent = selected.help;
        if (selected.prefix) {
          prefix.hidden = false;
          prefix.textContent = selected.prefix;
        } else {
          prefix.hidden = true;
          prefix.textContent = '';
        }
        visibleInput.value = selected.prefix === '@' ? stripPrefix(visibleInput.value, '@') : visibleInput.value;
        setTimeout(() => visibleInput.focus(), 0);
      } else {
        prefix.hidden = true;
        prefix.textContent = '';
      }
      updateStatus(card);
    };

    const render = (force = false) => {
      const raw = Number.parseInt(quantityInput?.value || '1', 10);
      const quantity = Math.min(Math.max(Number.isFinite(raw) ? raw : 1, 1), maxCards);
      if (!force && quantity === currentQuantity) return;
      const values = getValues();
      cardsContainer.innerHTML = Array.from({ length: quantity }, (_, index) => cardMarkup(index, values[index] || {})).join('');
      currentQuantity = quantity;
      configuredQuantity.value = String(quantity);
      const multiple = quantity > 1;
      quantityNote.hidden = !multiple;
      copyActions.hidden = !multiple;
      if (multiple) {
        quantityTitle.textContent = `${quantity} tarjetas`; 
        quantityCopy.textContent = 'Puedes guardar un contenido distinto en cada una.';
      }
      cardsContainer.querySelectorAll('[data-nsc-card]').forEach(updateStatus);
      updatePurchaseState();
    };

    root.addEventListener('click', (event) => {
      const destination = event.target.closest('[data-nsc-destination]');
      if (!destination) return;
      const card = destination.closest('[data-nsc-card]');
      setDestination(card, destination.dataset.value);
    });

    form.addEventListener('input', (event) => {
      const card = event.target.closest?.('[data-nsc-card]');
      if (!card) return;
      if (event.target.matches('[data-nsc-content-visible]')) updateHiddenContent(card);
      updateStatus(card);
    });

    const syncSoon = () => { setTimeout(() => render(), 0); setTimeout(() => render(), 80); };
    quantityInput?.addEventListener('input', syncSoon);
    quantityInput?.addEventListener('change', syncSoon);
    quantityInput?.closest('quantity-selector-component')?.addEventListener('click', syncSoon);

    copyButton?.addEventListener('click', () => {
      const cards = [...cardsContainer.querySelectorAll('[data-nsc-card]')];
      if (cards.length < 2) return;
      const source = getValues()[0];
      cards.slice(1).forEach((card) => {
        setDestination(card, source.type);
        const visibleInput = card.querySelector('[data-nsc-content-visible]');
        visibleInput.value = optionByValue(source.type)?.prefix === '@' ? stripPrefix(source.content, '@') : source.content;
        card.querySelector('[data-nsc-notes]').value = source.notes;
        updateStatus(card);
      });
      copyButton.innerHTML = '<span aria-hidden="true">✓</span> Copiado';
      setTimeout(() => { copyButton.innerHTML = '<span aria-hidden="true">＋</span> Copiar tarjeta 1 en el resto'; }, 1600);
    });

    form.addEventListener('submit', (event) => {
      if (updatePurchaseState()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const firstIncomplete = cardsContainer.querySelector('[data-nsc-card]:not(.is-complete)');
      firstIncomplete?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstIncomplete?.querySelector('[data-nsc-destination], [data-nsc-content-visible]')?.focus();
    }, true);

    form.addEventListener('click', (event) => {
      const paymentControl = event.target.closest('button[name="add"], .shopify-payment-button, .accelerated-checkout-block');
      if (!paymentControl || updatePurchaseState()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    render(true);
    setTimeout(updatePurchaseState, 300);
    setTimeout(updatePurchaseState, 1000);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-nsc-card-customizer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
